import React, { useState, useEffect } from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Divider,
  DatePicker,
  Radio,
  Spin,
} from "antd";
import AddPhysicianModalWrapper from "../../modal/AddPhysicianModalWrapper";
import { CustomButton, CustomSecondaryButton } from "../physician_page/styled";
import {
  libraryManagerService,
  physicianService,
} from "../../../services/user";
import { notify } from "../../../utils/helper";
import styled from "styled-components";
import moment from "moment";
import { countryCode } from "../../../utils/countryCode";

const { Option } = Select;

const FormContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* &::-webkit-scrollbar-track {
    background:rgb(138, 136, 136);
    border-radius: 10px;
  } */

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  .ant-picker {
    background: var(--primary-bg);
    color: var(--primary-text-color);
    height: 40px;
    border-radius: 6px;
    border: 1px solid var(--border-color);

    &:hover {
      border-color: #8a3ef4;
    }
  }
  .ant-picker-input > input {
    color: var(--primary-text-color);
  }
  .ant-picker-suffix {
    color: var(--primary-text-color);
  }
`;

const SectionTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  color: var(--primary-text-color);
  margin-bottom: 5px;
`;

const CustomPassword = styled.div`
  .ant-input-affix-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 1.5px 11px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 1.5715;
    background-color: transparent !important;
    background-image: none;
    border: 1px solid var(--border-color) !important;
    border-radius: 6px;
    transition: all 0.3s;
    display: inline-flex;
  }
`;

const AddLibraryManagerModal = ({
  isOpen,
  setOpen,
  isEdit,
  setIsEdit,
  libraryDataId,
  fetchLibraryManager,
}) => {
  const [libraryData, setLibraryData] = useState([]);
  const [phoneData, setPhoneData] = useState({
    countryCode: "91",
    number: "",
    short: "IN",
  });
  const [loading, setLoading] = useState(false);

  const createLibraryManager = async (managerData) => {
    try {
      setLoading(true);
      if (isEdit) {
        const res = await libraryManagerService.update(
          libraryDataId,
          managerData
        );
        notify("success", "Library Manager Updated Successfully.");
      } else {
        const response = await libraryManagerService.create(managerData);
        notify("success", "Library Manager Created Successfully.");
      }
      fetchLibraryManager();
      setIsEdit(false);
      setOpen(false);
      setLoading(false);
    } catch (error) {
      notify("error", error?.data?.message);
      setLoading(false);
    }
  };

  const getLibraryManagerById = async () => {
    try {
      const res = await physicianService.getById(libraryDataId);
      setLibraryData(res?.data);
    } catch (err) {}
  };

  useEffect(() => {
    if (isEdit) {
      getLibraryManagerById();
    }
  }, [libraryDataId]);

  const [form] = Form.useForm();
  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name: libraryData?.name || "",
        email: libraryData?.email || "",
        // role: DataById.role,
        // specialty: physicianData?.specialty || "N/A" || "",
        // status: physicianData?.status || "",
      });
    } else {
      form.setFieldsValue({
        name: "",
        email: "",
        // role: DataById.role,
        // specialty:  "",
      });
    }
  }, [libraryData, form, isEdit]);

  const onClose = () => {
    setIsEdit(false);
    setOpen(false);
  };

  const handleCountryChange = (value, option) => {
    const selectedCountry = countryCode.find(
      (country) => country?.name === value
    );
    const updatedPhoneData = {
      ...phoneData,
      countryCode: selectedCountry?.dial_code,
      short: selectedCountry?.code,
    };
    setPhoneData(updatedPhoneData);
  };

  const handlePhoneChange = (e) => {
    const phoneValue = e.target.value;
    setPhoneData({
      ...phoneData,
      number: phoneValue,
    });
  };

  return (
    <AddPhysicianModalWrapper
      show={isOpen}
      setShow={onClose}
      title={
        isEdit ? (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Update Library Manager
            </h3>
            <span className="font-15 text-secondry">
              Edit the library manager’s information.
            </span>
          </div>
        ) : (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Add New Library Manager
            </h3>
            <span className="font-15 text-secondry">
              Enter the details to add a new library manager to the platform.
            </span>
          </div>
        )
      }
      footer={null}
      width={550}
      keyClose={false}
      className="custom-detail-modal"
    >
    <Spin spinning={loading}>
      <Form
        form={form}
        layout="vertical"
        onFinish={createLibraryManager}
        // requiredMark="optional"
      >
        <FormContainer>
          <Row gutter={[24, 8]}>

            <Col span={24}>
              <Form.Item
                name="name"
                label="Full Name"
                rules={[
                  { required: true, message: "Please input the full name!" },
                ]}
              >
                <Input placeholder="Enter Full Name" size="large" />
              </Form.Item>
            </Col>

            {/* <Col span={12}>
              <Form.Item
                // name={["mobile", "number"]}
                label="Phone Number"
                rules={[
                  {
                    required: true,
                    message: "Please input your phone number!",
                  },
                ]}
              >
                <Input
                  addonBefore={
                    <Form.Item
                      // name={["mobile", "countryCode"]}
                      noStyle
                      rules={[{ required: true, message: "Code is required" }]}
                      initialValue={"+91"}
                    >
                      <Select
                        style={{ width: 90 }}
                        showSearch
                        onChange={handleCountryChange}
                        placeholder="Select country code"
                        optionLabelProp="label"
                        dropdownStyle={{ minWidth: 250 }}
                      >
                        {countryCode.map((country) => (
                          <Option
                            key={country.dial_code}
                            value={`+${country.dial_code}`}
                            // label={` ${country.code}  +${country.dial_code} `}
                            label={
                              <span>
                                <span style={{ fontSize: "12px" }}>
                                  {country.code}
                                </span>{" "}
                                +{country.dial_code}
                              </span>
                            }
                          >
                            <span style={{ fontSize: "10px" }}>
                              {country.code}
                            </span>
                            <span> {country.name}</span>
                            <span> +{country.dial_code}</span>
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  }
                  placeholder="Phone number"
                  onChange={handlePhoneChange}
                />
              </Form.Item>
            </Col> */}

            <Col span={24}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  {
                    type: "email",
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input placeholder="Email address" size="large" />
              </Form.Item>
            </Col>

            {/* <Col span={12}>
              <Form.Item
                // name="gender"
                label="Gender"
                rules={[
                  { required: true, message: "Please input your gender!" },
                  {
                    type: "Select",
                    message: "Please enter a valid gender",
                  },
                ]}
                initialValue={"male"}
              >
                <Radio.Group>
                  <Radio value="male">Male</Radio>
                  <Radio value="female">Female</Radio>
                </Radio.Group>
              </Form.Item>
            </Col> */}

            {/* <Col span={12}>
              <Form.Item
                // name="dateOfBirth"
                label="Date of Birth"
                rules={[
                  {
                    required: true,
                    message: "Please input your date of birth!",
                  },
                  {
                    type: "DatePicker",
                    message: "Please enter a valid date of birth",
                  },
                ]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  onChange={(date, dateString) => {
                    const formattedDate = moment(date).format("DD/MM/YYYY");
                  }}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col> */}

            {/* <Col span={12}>
              <Form.Item
                // name="country"
                label="Country"
                rules={[
                  { required: true, message: "Please input your country!" },
                  {
                    type: "Text",
                    message: "Please enter a valid country",
                  },
                ]}
              >
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  placeholder="Select Country"
                  size="large"
                  showSearch
                >
                  {countryCode.map((item) => (
                    <Option key={item.name} value={item.name}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}

            {/* <Col span={24}>
              <Form.Item
                // name="address"
                label="Address"
                rules={[
                  { required: true, message: "Please input your address!" },
                  {
                    type: "Text",
                    message: "Please enter a valid address",
                  },
                ]}
              >
                <Input placeholder="Address" size="large" />
              </Form.Item>
            </Col> */}

            {/* <Col span={24}>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  { required: true, message: "Please input a password!" },
                  {
                    min: 8,
                    message: "Password must be at least 8 characters!",
                  },
                ]}
              >
                <CustomPassword>
                  <Input.Password placeholder="Create password" size="large" />
                </CustomPassword>
              </Form.Item>
            </Col> */}
          </Row>
        </FormContainer>

        <Divider style={{ margin: "20px 0" }} />

        <Row>
          <Col span={24} className="d-flex justify-end gap-12">
            <CustomSecondaryButton
              onClick={() => {
                setIsEdit(false);
                setOpen(false);
              }}
            >
              Cancel
            </CustomSecondaryButton>
            <CustomButton htmlType="submit">
              {loading ? "Processing..." : isEdit ? "Update" : "Add Library Manager"}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </Spin>
    </AddPhysicianModalWrapper>
  );
};

export default AddLibraryManagerModal;
